import React from "react";
import Container from "./Container";
import { FaTwitter, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import VKotakte from "../Shared/SvgIcons/VKontakte";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <div className="h-3.5 w-[full] bg-primary"></div>
      <div className=" bg-footerBg">
        <Container>
          <div className="pb-20">
            <p className=" font-regular mx-auto w-[1240px] pt-12 pb-16 text-center font-pop text-base leading-6 text-primary">
              Find thousands of Auctions or classified ad listings from all over
              South Africa. Buy,sell or Auction items online.Earn money from
              selling your unwanted items or simply create a business
              listing.Create a free account and start bidding or buy something
              you like on efox.co.za
            </p>
            <div className="flex items-center justify-between ">
              <div className="flex w-[912px] items-center gap-x-5">
                <div className="w-[20%]">
                  <ul className="flex flex-col">
                    <Link to="/">
                      <li className="mb-5 font-pop text-base font-bold text-primary">
                        HOME
                      </li>
                    </Link>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      About us
                    </li>
                    <Link to="/register">
                      <li className="font-regular mb-2.5 font-roboto text-base text-white">
                        Register
                      </li>
                    </Link>
                    <Link to="/login">
                      <li className="font-regular mb-2.5 font-roboto text-base text-white">
                        Sign up
                      </li>
                    </Link>
                  </ul>
                </div>
                <div className="w-[20%]">
                  <ul className="flex flex-col">
                    <li className="mb-5 font-pop text-base font-bold text-primary">
                      LEGALITIES
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Privacy Policy
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Terms & Condition
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Cookies
                    </li>
                  </ul>
                </div>
                <div className="w-[35%]">
                  <ul className="flex flex-col">
                    <li className="mb-5 font-pop text-base font-bold text-primary">
                      RULES FOR ADS $ AUCTIONS
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      My Ad Does Not Show
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Advertise with Us
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Featured ads
                    </li>
                  </ul>
                </div>
                <div className="w-[25%]">
                  <ul className="flex flex-col">
                    <li className="mb-5 font-pop text-base font-bold text-primary">
                      HELP
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      My ad does not show
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Advertise with us
                    </li>
                    <li className="font-regular mb-2.5 font-roboto text-base text-white">
                      Privacy policy
                    </li>
                  </ul>
                </div>
              </div>
              <div className="w-[311px]">
                <div>
                  <p className="mb-6 font-pop text-sm font-medium text-white">
                    Designated trademarks and brands are the property of their
                    respective owners.Use of this Web Site constitutes
                    acceptance of our User Agreement.
                  </p>
                  <Link to="/register">
                    <button className="font-semiBold bg-primary py-2.5 px-12 font-pop text-sm text-white">
                      Create Account
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-solid border-primary border-opacity-40">
            <div className="flex w-[100%] pt-5 pb-7">
              <div className="w-[40%]">
                <p className="font-pop text-base font-medium text-white">
                  Copyright © 2022 efox.co.za All Rights Reserved.
                </p>
              </div>
              <div className="w-[30%]">
                <p className="font-pop text-base font-medium text-white">
                  Privacy Policy <span className="px-5">|</span> Terms of
                  Service
                </p>
              </div>
              <div className="flex w-[30%] items-center justify-end gap-x-12">
                <a href="https://facebook.com">
                  <FaFacebookF className="h-6 w-6 cursor-pointer text-white" />
                </a>
                <a href="https://twitter.com">
                  <FaTwitter className="h-6 w-6 cursor-pointer text-white" />
                </a>
                <a href="https://linkedin.com">
                  <FaLinkedinIn className="h-6 w-6 cursor-pointer text-white" />
                </a>
                <a href="https://vk.com">
                  <VKotakte className="h-6 w-6 cursor-pointer text-white" />
                </a>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Footer;
